import { Box, Button, FormControlLabel, Typography } from '@mui/material';
import "./UserGigAgreementPage.scss";
import pageTextConfig from "../../../assets/configs/Add New Gig Page/FinalVerificationPage/textConfig";
import tipsIcon from "../../../assets/images/AddNewGigPage/tips_icon_red.png";
import Checkbox from '@mui/material/Checkbox';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import DoneAllIcon from '@mui/icons-material/DoneAll';

import { useRef, useState } from 'react';
import SnackBar, { SnackTypes } from '../../../components/UtilityComponents/SnackBar/SnackBar';
interface UserGigAgreementPageProps {
  setCurrentPage: any;
  submitForm: Function;
}

const UserGigAgreementPage = ({
  setCurrentPage,
  submitForm
}: UserGigAgreementPageProps) => {

  let [termsAndconditionsAgreed, setTermsAndconditionsAgreed] = useState([false, false, false, false]);
  // Snackbar based status handling 
  const snackBarRef = useRef<{ showSnackbar(): any }>(null)
  const [snackBarParams, setSnackBarParams] = useState({
    message: "",
    state: SnackTypes.error
  });

  const showSnackbar = (message: string, state: SnackTypes) => {
    setSnackBarParams({ message: message, state: state })
    snackBarRef.current?.showSnackbar()
  }

  function updateAgreedTnCList(agreementId: number) {
    let updatedList = termsAndconditionsAgreed.map((checkStatus, index) => {
      if (agreementId === index) {
        return !checkStatus
      } 
      return checkStatus
    })

    setTermsAndconditionsAgreed(updatedList)
  }

  const handleFinalSubmission = () => {
    let allChecked = true
    termsAndconditionsAgreed.forEach(condition => {
      if (!condition) {
        allChecked = false
        showSnackbar("Please checkmark all the boxes", SnackTypes.error);
        return
      }
    })
    if (allChecked)
      submitForm()
  }

  return (
    <Box className='user-agreement-page'>
      <Box className = 'main-container'>
        <Box className="form-container">
            <Box className="tips-box">
                  <img src={tipsIcon} className ="tip-icon" alt="Quick Tip"/>

                  <Typography variant='body1' className="tip-text" >
                    {pageTextConfig.warning.description}
                  </Typography>

            </Box>
            {
              termsAndconditionsAgreed.map((_isChecked, index) => (
                <FormControlLabel 
                control={<Checkbox 
                            checked={termsAndconditionsAgreed[index]}
                            onChange={() => updateAgreedTnCList(index)} />} 
                label={pageTextConfig.termsAndConditions[index]} />
              ))
            }
        </Box>

        <Box className="page-navigation-button-bar">
          <Button className="secondary-black-button" variant='outlined' startIcon={<KeyboardDoubleArrowLeftIcon />} size="large" sx={{width: '200px', marginTop: '30px', marginRight: '15px'}}
            onClick={() => setCurrentPage((currentPage: number) => currentPage - 1)}
          >Previous
          </Button>

          <Button 
            className="submit-button" 
            variant='outlined' 
            endIcon={<DoneAllIcon />} 
            size="large" 
            sx={{width: '200px', marginTop: '30px'}}
            onClick={handleFinalSubmission}>
            Submit
          </Button>
        </Box>
      </Box>
      <SnackBar ref={snackBarRef} severity={snackBarParams.state} alertDuration={5000} message={snackBarParams.message} />
    </Box>
  )
}

export default UserGigAgreementPage